import { MODULOS } from './perfiles.js'

// Colores optimizados para tema oscuro
// Cada módulo tiene su color vibrante que se usa como acento
export const MODULOS_COLORES = {
  [MODULOS.ARMERIA]: {
    surface: '#1E1E2E',
    secondary: '#6C5CE7', // Púrpura vibrante
    accent: '#A29BFE',
    anchor: '#6C5CE7',
  },
  [MODULOS.EQUIPAMIENTO]: {
    surface: '#2E2416',
    secondary: '#FF9F43', // Naranja vibrante
    accent: '#FFBE76',
    anchor: '#FF9F43',
  },
  [MODULOS.PROFESIONALIZACION]: {
    surface: '#1A2E24',
    secondary: '#00D2A0', // Verde vibrante
    accent: '#26DE81',
    anchor: '#00D2A0',
  },
  [MODULOS.DESARROLLO_POLICIAL]: {
    surface: '#2E2416',
    secondary: '#FFA502', // Amarillo-naranja vibrante
    accent: '#FFD32A',
    anchor: '#FFA502',
  },
  [MODULOS.ENLACE_C3]: {
    surface: '#2E2416',
    secondary: '#FFA502',
    accent: '#FFD32A',
    anchor: '#FFA502',
  },
  [MODULOS.RECURSOS_HUMANOS]: {
    surface: '#2E1A1A',
    secondary: '#EE5A6F', // Rojo vibrante
    accent: '#FC5C65',
    anchor: '#EE5A6F',
  },
  [MODULOS.REGISTRO_PERSONAL]: {
    surface: '#2A1816',
    secondary: '#C23616', // Rojo oscuro vibrante
    accent: '#E74C3C',
    anchor: '#C23616',
  },
  [MODULOS.CONSULTA_PERSONAL]: {
    surface: '#1A2E1A',
    secondary: '#26DE81', // Verde brillante
    accent: '#20BF6B',
    anchor: '#26DE81',
  },
  [MODULOS.ENLACE]: {
    surface: '#1A2A2E',
    secondary: '#45AAF2', // Azul cielo
    accent: '#4B7BEC',
    anchor: '#45AAF2',
  },
  [MODULOS.POLICIA]: {
    surface: '#0F1C2E',
    secondary: '#1E90FF', // Azul institucional
    accent: '#74B9FF',
    anchor: '#1E90FF',
  },
}
